module.exports = __webpack_public_path__ + "img/management-services-bottom-photo.ecbbc558.jpg";